export const ADD_PARTICIPANT = "ADD_PARTICIPANT";
export const EDIT_FORM = "EDIT_FORM";
export const FORM_ERROR = "FORM_ERROR";
export const REMOVE_PARTICIPANT = "REMOVE_PARTICIPANT";
export const ADD_WINNER = "ADD_WINNER";
export const DECREASE_TICKETS_FOR_PARTICIPANT =
  "DECREASE_TICKETS_FOR_PARTICIPANT";
export const RESET = "RESET";
export const SET_PARTICIPANTS = "SET_PARTICIPANTS";
